import React from 'react';
import ButtonLoader from '../../../UI/Loader/Loader';
import * as S from './AppButon.styles';

const AppButon = ({
  onPress,
  classes,
  buttonText,
  isError,
  isDisabled,
  butonWidth,
  isLoading = false,
  type,
}) => {
  return !isLoading ? (
    <S.Btn
      butonWidth={butonWidth}
      isDisabled={isDisabled}
      isError={isError}
      onClick={onPress}
      className={classes}
      type={type ? type : 'button'}
    >
      {buttonText}
    </S.Btn>
  ) : (
    <S.BtnLoader
      butonWidth={butonWidth}
      isDisabled={isDisabled}
      isError={isError}
      className={classes}
    >
      <ButtonLoader loaderType="button" />
    </S.BtnLoader>
  );
};

export default AppButon;
